import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

import Footer from "./footer";
import Blogs from "./Blogs";
import FundamentalsDisplay from "./FundamentalsDisplay";
import CompanyHighlights from "./CompanyHighlights";
import ReportsDisplay from "./ReportsDisplay";
import "./CompanyDetails.css";


function CompanyDetailPage() {
  const { id } = useParams(); // company id from URL
  const navigate = useNavigate();

  const [company, setCompany] = useState(null);
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Promise.all([
      // 🔹 FETCH ALL COMPANIES → FIND MATCHING ID
      fetch("https://api.niveshly.com/companies")
        .then(res => res.json())
        .then(companies =>
          companies.find(c => String(c.id) === String(id))
        ),

      // 🔹 FETCH ALL DETAILS → MATCH company_id
      fetch("https://api.niveshly.com/company-details")
        .then(res => res.json())
        .then(details =>
          details.find(d => String(d.company_id) === String(id))
        )
    ])
      .then(([companyData, detailsData]) => {
        setCompany(companyData || null);
        setDetails(detailsData || null);
      })
      .catch(() => {
        setCompany(null);
        setDetails(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p style={{ padding: 40 }}>Loading...</p>;
  if (!company) return <p style={{ padding: 40 }}>Company not found</p>;

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f5f7fa" }}>
      <div style={{ padding: "40px 20px", maxWidth: "1400px", margin: "0 auto" }}>

        {/* BACK */}
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "10px 20px",
            backgroundColor: "#4f46e5",
            color: "white",
            border: "none",
            borderRadius: "8px",
            marginBottom: "30px",
            cursor: "pointer"
          }}
        >
          ← Back to Companies
        </button>

        {/* HEADER FROM /companies */}
        <div className="company-header-card">
          <div className="company-header">
            <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
              <img src={company.logo} alt={company.name} style={{ width: 50 }} />
              <h2 style={{ margin: 0 }}>{company.name}</h2>
            </div>
          </div>
        </div>
        {/* about company  */}
        {/* ABOUT COMPANY */}
        {details?.about_company && (
          <div className="about-company-section">
            <h3>About Company</h3>
            <div
              className="about-company-content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(details.about_company),
              }}
            />
          </div>
        )}

        {/* FUNDAMENTALS */}
        {details?.fundamentals && (
          <FundamentalsDisplay data={details.fundamentals} />
        )}

        {/* HIGHLIGHTS */}
        {details?.highlights?.length > 0 && (
          <CompanyHighlights data={details.highlights} />
        )}

        {/* REPORTS */}
        {details?.reports?.length > 0 && (
          <ReportsDisplay data={details.reports} />
        )}

        {/* KEY PEOPLE */}
        {details?.key_people?.length > 0 && (
          <div className="key-people-section">
            <h3>👥 Key People</h3>
            {details.key_people.map((kp, i) => (
              <div className="key-person" key={i}>
                <span className="name">{kp.name}</span>
                <span className="title">{kp.title}</span>
              </div>
            ))}
          </div>
        )}

        <Blogs />
        <Footer />
      </div>
    </div>
  );
}

export default CompanyDetailPage;
